import { Grid, Hidden } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'

import useStyles from './styles/rightHalfLayout'

const RightHalfLayout: React.FC = ({ children }) => {
  const classes = useStyles()

  return (
    <Hidden smDown>
      {children && (
        <Grid
          alignItems="flex-start"
          className={classes.rightHalfLayout}
          container
          item
          justify="center"
          md={5}
        >
          <Grid
            alignItems="center"
            container
            direction="column"
            item
            justify="center"
            sm={10}
            wrap="nowrap"
            xs={12}
          >
            {children}
          </Grid>
        </Grid>
      )}
    </Hidden>
  )
}

const StyledRightHalfLayout = styled(RightHalfLayout)``

export default StyledRightHalfLayout
